import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { useGetTeacherRoutes } from '@teetsh/app/src/containers/Header/useGetTeacherRoutes';
import { ButtonClose } from '@teetsh/app/src/containers/Sidebar/components/ButtonClose';
import { Logo } from '@teetsh/app/src/containers/Sidebar/components/Logo';
import { SearchItem } from '@teetsh/app/src/containers/Sidebar/components/SearchItem';
import { SidebarWrapper } from '@teetsh/app/src/containers/Sidebar';
import { NavItem } from '@teetsh/app/src/containers/Sidebar/NavItem';
import { useSidebarStatus } from '@teetsh/app/src/containers/Sidebar/useSidebarStatus';
import { useUserRoles } from '@teetsh/app/src/containers/App/context/useUserRoles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import tw from 'twin.macro';

export function SidebarTeacher() {
  const location = useLocation();
  const { isOpen } = useSidebarStatus();
  const items = useGetTeacherRoutes();
  const { t } = useTranslation(['common']);
  const { hasRoleDirector } = useUserRoles();

  return (
    <SidebarWrapper>
      <div
        css={[
          tw`flex justify-between mb-6 sm:px-2 relative`,
          isOpen && tw`visible pr-3`,
          !isOpen && tw`invisible`,
        ]}
      >
        <Logo theme="dark" />

        <div tw="block lg:hidden">
          <ButtonClose />
        </div>
      </div>
      <div tw="flex flex-col flex-grow mb-4">
        <SearchItem isOpen={isOpen} />
        {items.map(item => (
          <NavItem
            key={item.route}
            minimal={!isOpen}
            item={item}
            pathname={location.pathname}
            theme="dark"
          />
        ))}
      </div>
      {hasRoleDirector && (
        <ButtonLink
          outlined
          tw="text-white"
          intent="primary"
          to="/direction/settings/account"
          fill
          icon={ArrowsRightLeftIcon}
          aria-label="Compte enseignant"
        >
          {isOpen && t('common:directorAccount')}
        </ButtonLink>
      )}
    </SidebarWrapper>
  );
}
